import React, { FC } from "react";
import { Button } from "../../components";
import { useAppDispatch, useAppSelector } from "../../store";
import appConfig from "../../util/appConfig";
import { updateAdminEigentuemerwechselItemStatusById } from "../../store/slices/eigentuemerwechsel";

interface IViersen {
  itemId: string;
}

const Viersen: FC<IViersen> = ({ itemId }) => {
  const dispatch = useAppDispatch();
  const { eigentuemerwechselItem } = useAppSelector(
    (state) => state.eigentuemerwechsel.admin,
  );

  if (!eigentuemerwechselItem) {
    return null;
  }

  if (eigentuemerwechselItem && eigentuemerwechselItem?.status === "accepted") {
    return null;
  }

  return (
    <div
      style={{
        // textAlign: "end",
        display: "flex",
        justifyContent: "space-between",
        marginTop: "30px",
      }}
    >
      <Button
        text="Fertig"
        width="200"
        backgroundColor={appConfig.mainColor}
        onClick={() => {
          if (itemId) {
            dispatch(
              updateAdminEigentuemerwechselItemStatusById({
                id: itemId,
                status: "accepted",
              }),
            );
          }
        }}
      />
      <Button
        text="Stornieren"
        width="200"
        backgroundColor="white"
        isOutlined
        outlineColor={"red"}
        textColor={"red"}
        onClick={() => {
          if (itemId) {
            dispatch(
              updateAdminEigentuemerwechselItemStatusById({
                id: itemId,
                status: "accepted",
              }),
            );
          }
        }}
      />
    </div>
  );
};

export default Viersen;
